// declare global{
//   export interface Window{
//     document:Document
//   }
//   // export interface document{

//   // }
//   export interface Document {
//     webkitHidden: any;
//   }
// }
export interface Window {
  document: Document
}
export interface Document {
}
interface Size {
  w?: string | number,
  h?: string | number,
  etw?: string | number,
  eth?: string | number,
}
interface KingParams {
  m?: string | number,
  w?: number,
  h?: number,
  q?: string | number,
  F?: string | number,
  r?: string | number,
  c?: string | number,
  f?: string | number,
  s?: string | number,
  cox?: string | number,
  coy?: string | number,
  rotate?: string | number,
  et?: string | number,
  etw?: string | number,
  eth?: string | number,
  etc?: string | number
}
interface KingParamsReg {
  m: RegExp,
  w: RegExp,
  h: RegExp,
  q: RegExp,
  F: RegExp,
  r: RegExp,
  c: RegExp,
  f: RegExp,
  s: RegExp,
  cox: RegExp,
  coy: RegExp,
  rotate: RegExp,
  et: RegExp,
  etw: RegExp,
  eth: RegExp,
  etc: RegExp
}
import { isEmpty } from "../utils/index";
import reg from "../utils/reg";
import qs from "query-string";
// import qs from "../utils/qs.js";
import {
  isWeex,
  isReactNative,
  isMiniApp,
  isTTMiniApp,
  isIOS,
  isAndroid
} from "../utils/env";
const urlReg = /^http.+(youpin\.mi-img\.com\/).+(\.jpg|\.jpeg|\.png)($|@.+|\?.*)/
class YoupinImg {
  webp: boolean;
  cache: any;
  keyCache: string;
  constructor() {
    this.webp = false;
    this.cache = {};
  }
  init() {
    this.isSupportWebp();
  }

  resize(url: string, params: KingParams) {
    if (
      url === "" ||
      Object.prototype.toString.call(url) !== "[object String]"
    ) {
      return "";
    }
    // 只处理金山云图片,不处理gif图，会出现变色bug
    // if (url.indexOf("img.youpin.mi-img.com") > -1 && url.toLocaleLowerCase().indexOf(".gif") === -1 && url.toLocaleLowerCase().indexOf(".webp") === -1) {
    if (urlReg.test(url.toLocaleLowerCase())) {
      url = url.replace("http://", "https://");
      // 需要更改参数的
      if (
        isEmpty(params) !== "" &&
        JSON.stringify(params) !== "{}" &&
        Object.prototype.toString.call(params) === "[object Object]"
      ) {
        // 兼容传小数的情况
        if (params.w) {
          params.w = Math.ceil(params.w);
        }
        if (params.h) {
          params.h = Math.ceil(params.h);
        }
        // 如果设置了宽高，但是不符合要求，比如小于0或者大于4000，就不处理了，金山云最大允许4000
        if ((params['w'] && !reg['w'].test(String(params.w))) || (params['h'] && !reg['h'].test(String(params.h)))) {
          return url
        }
        // 缓存参数做key,缓存原始url，如果cache里有key，就不用qs处理了
        const paramsCache = JSON.stringify(params)
        const urlCache = url
        let keyCache = '' 
        url = url.split("?")[0].split("&")[0];
        if (url.indexOf("@base") === -1) {
          // 按照最大使用场景做了缓存，其他场景使用情况不高先不加缓存了
          keyCache = urlCache.replace(url, '') + paramsCache
          url = url + "@base@tag=imgScale";
          if(keyCache && this.cache[keyCache]){
            return url + this.cache[keyCache]
          } else {
            this.cache[keyCache] = ''
          }
        } else {
          url = url.split("&")[0];
        }
        // 兼容各种参数写法
        let obj:any = { ...qs.parse(urlCache), ...qs.parse(urlCache.split("?")[1]) };
        if (this.webp) {
          obj = { ...obj, ...params, F: "webp" };
        } else {
          obj = { ...obj, ...params };
          if (obj.F === "webp") {
            delete obj.F;
          }
        }
        url = this.addParams(url, obj, keyCache);
        return url;
      } else {
        if (this.webp && url.indexOf("F=webp") === -1) {
          let defaultParams = "";
          let obj = { ...qs.parse(url), ...qs.parse(url.split("?")[0]), ...qs.parse(url.split("?")[1]) };
          if (url.split("?").length > 1) {
            defaultParams = url.split("?")[1];
          }
          url = url.split("?")[0].split("&")[0];
          if (url.indexOf("@base") === -1) {
            url = `${url}@base@tag=imgScale&F=webp`;
            url = this.addParams(url, { ...obj });
          } else {
            url = this.addParams(url, { ...obj, F: "webp" });
          }
          if (defaultParams !== "") {
            url = `${url}?${defaultParams}`;
          }
        }
        return url;
      }
    } else {
      // console.log("not kingsoft img");
      return url;
    }
  }
  /**
   * 获取尺寸
   * @param url 
   */
  getSize(url: string) {
    let w: any = undefined;
    let h: any = undefined;
    let whScale = 1;
    try {
      if (
        url !== "" &&
        Object.prototype.toString.call(url) === "[object String]"
      ) {
        if (url.indexOf("?") > -1) {
          url = url.split("?")[1];
        }
        if (url.indexOf("@base") > -1) {
          url = url.split("@base")[1];
        }
        let size: Size = qs.parse(url);
        // 有背景值情况取背景值
        w = Number(size["etw"]) || Number(size["w"]) || undefined;
        h = Number(size["eth"]) || Number(size["h"]) || undefined;
        whScale = w / h || 1;
      }
    } catch (error) { }
    return { w, h, whScale };
  }
  /**
   * 还原url
   * @param url 
   */
  recover(url: string) {
    if (
      url === "" ||
      Object.prototype.toString.call(url) !== "[object String]"
    ) {
      return "";
    }
    if (urlReg.test(url.toLocaleLowerCase())) {
      if (url.indexOf('@base') > -1) {
        if (url.indexOf('?') > -1) {
          let query = url.split("?")[1]
          url = url.split('@')[0] + '?' + query
        } else {
          url = url.split('@')[0]
        }
      }
    }
    return url
  }
  addParams(url: string, params: any, keyCache?: string) {
    const defaultMap: KingParamsReg | any = reg;
    let newParams: KingParams | any = {};
    // 有mode/fix/cut一个或多个参数时，w和参数h必须设定其中一个
    if(params.m  && !(params.w || params.h)){
      delete params.m;
    }
    // "height和width参数仅设定一个时，不能设定fix/cut"
    if((params.cox || params.coy || params.c|| params.f) && (!params.w || !params.h)){
      delete params.c;
      delete params.f;
      delete params.cox;
      delete params.coy;
    }
    // 只追加已知参数
    for (const key in params) {
      if (defaultMap.hasOwnProperty(key) && defaultMap[key].test(params[key])) {
        newParams[key] = params[key];
      }
    }
    const qsParams = qs.stringify(newParams)
    if (qsParams !== "") {
      url = url + "&" + qsParams;
      if(keyCache){
        this.cache[keyCache] = "&" + qsParams;
      }
    }
    return url;
  }
  // 判断是否支持webp
  isSupportWebp() {
    try {
      if (isWeex || isReactNative) {
        this.webp = true;
        return true;
      }
      if ((isMiniApp || isTTMiniApp) && isAndroid) {
        this.webp = true;
        return true;
      }
      if (isIOS) {
        this.webp = false;
        return false;
      }

      // 安卓web端
      let webp =
        window.document
          .createElement("canvas")
          .toDataURL("image/webp")
          .indexOf("data:image/webp") == 0;
      this.webp = webp;
      return webp;
      // 以下方法会有异步的问题
      // let WebP = new Image();
      // WebP.onload = WebP.onerror = () => {
      //   if (WebP.height != 2) {
      //     this.webp = false;
      //   } else {
      //     this.webp = true;
      //   }
      // };
      // WebP.src =
      //   "data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA";
    } catch (error) { }
  }
}

const youpinImg = new YoupinImg(); // 初始化判断是否支持webp，只执行一次，防止多次调用

youpinImg.init();

export const resize = function (url:string, params:KingParams) {
  try {
    return youpinImg.resize(url, params);
  } catch (error) {
    return url;
  }
};

export const getSize = function (url:string) {
  return youpinImg.getSize(url);
};
export const recover = function(url:string) {
  return youpinImg.recover(url);
};

export default youpinImg;
